import React, {Fragment } from 'react';
import { 
    FormDataConsumer,
    TextInput ,
} from 'react-admin';
import { useForm } from 'react-final-form';
import TableCell from '@material-ui/core/TableCell';

const getValidate=(val) => {
    let dummy= null;
    if(!val || parseFloat(val) < 6.0 || parseFloat(val) > 9.0){
        dummy = (document.getElementById("tx_protein"))? document.getElementById("tx_protein").setAttribute("style", "color: red;"): null;
    }else{
        dummy = (document.getElementById("tx_protein"))?document.getElementById("tx_protein").removeAttribute("style"):null;
    }
    
    return val
}


const OrderOrigin = ({ formData, ...rest }) => {
    const form = useForm();

    return (
        <Fragment>
             <TableCell >
                <TextInput 
                    id="tx_protein"
                    source="total_protein" 
                    label=""
                    onChange ={getValidate(formData.total_protein),
                        formData.total_protein = getValidate(formData.total_protein) 
                    }
                    {...rest}
                    />
             </TableCell>          
        </Fragment>
    );
};
const Protein = ({...props}) => (

    <FormDataConsumer>
        {formDataProps => (
            <OrderOrigin {...formDataProps} />
        )}
    </FormDataConsumer>
);

export default Protein